import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { hourlyContractsBackend } from './hourly-contracts.backend';
import { hourlyContractsReducer } from './hourly-contracts.reducer';

// FIXME: remove that
backend.hourlyContracts = hourlyContractsBackend;

@NgModule({
  imports: [StoreModule.forFeature('hourlyContracts', hourlyContractsReducer)],
})
export class DatastoreHourlyContractsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/hourly-contracts/hourly-contracts.module.ts